export const formatCompanyName = (companyAddress?: string | null): string => {
  if (!companyAddress) {
    return "";
  }

  const companyName = companyAddress.split("\n")[0];
  return `(${companyName})`;
};
